import {
  USER_CAMPAIGN_GET_REQUESTING,
  USER_CAMPAIGN_GET_SUCCESS,
  USER_CAMPAIGN_GET_ERROR,
  USER_CAMPAIGN_SELECT,
  USER_CAMPAIGN_GET_TEAM_SUCCESS,
  USER_CAMPAIGN_GET_TEAM_ERROR,
  USER_CAMPAIGN_GET_TEAM_REQUESTING,
  USER_CAMPAIGN_NEW,
  SELECT_PERFECT_STEP_ERROR,
  SELECT_PERFECT_STEP_REQUESTING,
  SELECT_PERFECT_STEP_SUCCESS,
  ACCEPT_PERFECT_STEP_ERROR,
  ACCEPT_PERFECT_STEP_REQUESTING,
  ACCEPT_PERFECT_STEP_SUCCESS,
  VALIDATE_PERFECT_STEP_REQUESTING,
  VALIDATE_PERFECT_STEP_ERROR,
  VALIDATE_PERFECT_STEP_SUCCESS,
  SELECT_STEP,
  USER_CAMPAIGN_SET_USER_RANK,
  USER_CAMPAIGN_SET_TEAM_RANK,
  USER_CAMPAIGN_SET_TEAM,
  USER_CAMPAIGN_GET_USER_RANK_REQUESTING,
  USER_CAMPAIGN_GET_USER_RANK_SUCCESS,
  USER_CAMPAIGN_GET_USER_RANK_ERROR,
  USER_CAMPAIGN_GET_TEAM_RANK_REQUESTING,
  USER_CAMPAIGN_GET_TEAM_RANK_SUCCESS,
  USER_CAMPAIGN_GET_TEAM_RANK_ERROR,
  USER_CAMPAIGN_SET_NEXT_CATEGORY_REQUESTING,
  USER_CAMPAIGN_SET_NEXT_CATEGORY_SUCCESS,
  USER_CAMPAIGN_GET_ALL_SUCCESS,
  USER_CAMPAIGN_GET_ALL_ERROR,
  USER_CAMPAIGN_GET_ALL_REQUESTING,
  USER_CAMPAIGN_DELETE,
  GET_CURRENT_USER_CAMPAIGN_REQUESTING,
  GET_CURRENT_USER_CAMPAIGN_ERROR,
  GET_CURRENT_USER_CAMPAIGN_SUCCESS,
  CAMPAIGN_JOIN_REQUESTING,
  CAMPAIGN_JOIN_SUCCESS,
  CAMPAIGN_JOIN_ERROR,
  SELECT_RECOMMENDED_STEPS_REQUESTING,
  SELECT_RECOMMENDED_STEPS_ERROR,
  SELECT_RECOMMENDED_STEPS_SUCCESS,
  GET_SPECIFIC_STEP_REQUESTING,
  GET_SPECIFIC_STEP_SUCCESS,
  GET_SPECIFIC_STEP_ERROR,
  GET_CAMPAIGN_REVIEWS_REQUESTING,
  GET_CAMPAIGN_REVIEWS_SUCCESS,
  GET_CAMPAIGN_REVIEWS_ERROR,
  UPDATE_REVIEW_REQUESTING,
  UPDATE_REVIEW_SUCCESS,
  UPDATE_REVIEW_ERROR,
  COMMENT_REVIEW_SUCCESS,
  UPDATE_STEP_FEEDBACK_FILE,
  CANCEL_SELECTED_STEP_REQUESTING,
  CANCEL_SELECTED_STEP_SUCCESS,
  CANCEL_SELECTED_STEP_ERROR,
  ADD_STEP_COMMENT_SUCCESS,
  REMOVE_COMMENT_SUCCESS,
  UPDATE_COMMENT_SUCCESS,
  GET_STEP_COMMENT_SUCCESS,
  GET_STEP_COMMENT_INFO_SUCCESS,
  GET_ALL_RESPONSES_SUCCESS,
  GET_ALL_RESPONSES_REQUESTING,
  SEND_RESPONSE_SUCCESS,
  SEND_RESPONSE_REQUESTING,
  REMOVE_COMMENT_REQUESTING,
  GET_STEP_COMMENT_REQUESTING,
  GET_STEP_COMMENT_ERROR,
  ADD_LIKE_STEP_COMMENT_REQUESTING,
  REMOVE_LIKE_STEP_COMMENT_REQUESTING,
  GET_EVENTS_REQUESTING,
  GET_EVENTS_SUCCESS,
  GET_EVENTS_ERROR,
} from "./constants";

import { cloneDeep } from "lodash";
import produce from "immer";
import moment from "moment";

import { LOGOUT } from "../login/constants";
import { defaultStep } from "./defaultStates";
import { UPDATE_TEAM_SUCCESS } from "../team/constants";
import { IUserCampaignReducer } from "./types";

const initialState: IUserCampaignReducer = {
  _id: "",
  campaignId: "",
  requesting: false,
  userRankRequesting: false,
  teamRankRequesting: false,
  isValidateRequesting: false,
  selectionRequesting: false,
  campaignsRequesting: false,
  reviewsRequesting: false,
  error: "",
  userCampaigns: [],
  teamRequesting: false,
  team: { users: [] },
  recommendedSteps: [],
  stepSelectedIndex: 0,
  stepFeedbacks: [],
  stepSelected: defaultStep,
  stepFeedbackSelectedId: "",
  pictureData: "",
  events: [
    {
      title: "Nouveau defi",
      campaignId: "",
      user: "",
      date: moment().add(3, "day").toDate(),
    },
  ],
  campaignSelected: {
    _id: "",
    trackId: "",
    title: { fr: "", en: "" },
    campaignId: "",
    skills: [],
    steps: [],
    templateLabel: { fr: "", en: "" },
    allStepsViews: [],
    stepRepetition: [],
    nextCategory: "",
    isCoachingCampaign: false,
    isRankingDisabled: false,
    teamSize: 0,
    resourcesStats: [],
    debriefText: {},
    isFeedbackRequired: false,
    hasReviews: false,
    hasRequestedForNewActions: null,
    hasPeerToPeer: false,
    points: 0,
    weekStreak: 0,
    events: [],
    campaignActionGoal: 6,
    certificateUrl: "",
  },
  userRank: 1,
  teamRank: 1,
  previousTeamRank: 1,
  previousUserRank: 1,
  previousTeamPoints: 0,
  previousTeamWeekPoints: 0
};

const reducer = function actionReducer(
  state: IUserCampaignReducer = initialState,
  action,
): IUserCampaignReducer {
  switch (action.type) {
    case UPDATE_TEAM_SUCCESS:
      return {
        ...state,
        requesting: false,
        team: action.payload,
        pictureData: initialState.pictureData,
      };

    case SELECT_STEP: {
      const { stepSelected, stepSelectedIndex } = action.payload;

      return {
        ...state,
        stepSelected: { ...stepSelected } || state.stepSelected,
        stepSelectedIndex,
      };
    }

    case USER_CAMPAIGN_GET_ALL_REQUESTING:
      return {
        ...state,
        campaignsRequesting: true,
      };

    case VALIDATE_PERFECT_STEP_REQUESTING:
      return {
        ...state,
        error: "",
        isValidateRequesting: true,
      };

    case GET_SPECIFIC_STEP_REQUESTING:
    case SELECT_RECOMMENDED_STEPS_REQUESTING:
    case CAMPAIGN_JOIN_REQUESTING:
    case GET_CURRENT_USER_CAMPAIGN_REQUESTING:
    case SELECT_PERFECT_STEP_REQUESTING:
    case USER_CAMPAIGN_GET_REQUESTING: {
      return {
        ...state,
        error: "",
        requesting: true,
      };
    }

    case UPDATE_REVIEW_REQUESTING:
    case GET_CAMPAIGN_REVIEWS_REQUESTING:
      return {
        ...state,
        error: "",
        reviewsRequesting: true,
      };

    case GET_CAMPAIGN_REVIEWS_SUCCESS:
      return {
        ...state,
        error: "",
        stepFeedbacks: action.payload,
        reviewsRequesting: false,
      };

    case UPDATE_STEP_FEEDBACK_FILE: {
      const stepFeedbacks = state.stepFeedbacks.map(el => {
        if (el._id === action.payload?.data?.stepFeedbackId) {
          const files = el.files.map(file => {
            if (file._id === action.payload._id) {
              return { ...file, ...action.payload };
            }
            return file;
          });

          return {
            ...el,
            files,
          };
        }
        return el;
      });

      return {
        ...state,
        stepFeedbacks,
      };
    }

    case COMMENT_REVIEW_SUCCESS: {
      const stepFeedbacks = state.stepFeedbacks.map(el => {
        if (el._id === action.payload._id) {
          return {
            ...cloneDeep(el),
            ...cloneDeep(action.payload),
            files: el.files,
            stepId: el.stepId,
          };
        }
        return el;
      });

      return {
        ...state,
        error: "",
        stepFeedbacks,
        reviewsRequesting: false,
      };
    }

    case UPDATE_REVIEW_SUCCESS: {
      const stepFeedbacks = state.stepFeedbacks.map(el => {
        if (el._id === action.payload._id) {
          return {
            ...cloneDeep(el),
            ...cloneDeep(action.payload),
            stepId: el.stepId,
          };
        }
        return el;
      });

      return {
        ...state,
        error: "",
        stepFeedbacks,
        reviewsRequesting: false,
      };
    }

    case UPDATE_REVIEW_ERROR:
    case GET_CAMPAIGN_REVIEWS_ERROR:
      return {
        ...state,
        error: action.payload,
        reviewsRequesting: false,
      };

    case SELECT_RECOMMENDED_STEPS_SUCCESS:
      return {
        ...state,
        error: "",
        requesting: false,
        recommendedSteps: action.payload,
      };

    case GET_CURRENT_USER_CAMPAIGN_SUCCESS:
      return {
        ...state,
        requesting: false,
        campaignSelected: action.payload,
      };

    case USER_CAMPAIGN_GET_USER_RANK_REQUESTING:
      return {
        ...state,
        userRankRequesting: true,
      };

    case USER_CAMPAIGN_GET_USER_RANK_SUCCESS:
      return {
        ...state,
        previousUserRank: action.payload !== state.userRank ? state.userRank : state.previousUserRank,
        userRank: action.payload,
        userRankRequesting: false,
      };

    case USER_CAMPAIGN_GET_USER_RANK_ERROR:
      return {
        ...state,
        error: action.payload,
        userRankRequesting: false,
      };

    case USER_CAMPAIGN_GET_TEAM_RANK_REQUESTING:
      return {
        ...state,
        teamRankRequesting: true,
      };

    case USER_CAMPAIGN_GET_TEAM_RANK_SUCCESS:

      return {
        ...state,
        previousTeamRank: action.payload !== state.teamRank ? state.teamRank : state.previousTeamRank,
        teamRank: action.payload,
        teamRankRequesting: false,
      };

    case USER_CAMPAIGN_GET_TEAM_RANK_ERROR:
      return {
        ...state,
        error: action.payload,
        teamRankRequesting: false,
      };

    case GET_EVENTS_REQUESTING:
      return {
        ...state,
        eventsRequesting: true,
      };

    case GET_EVENTS_SUCCESS:
      return {
        ...state,
        events: action.payload,
        eventsRequesting: false,
      };

    case GET_EVENTS_ERROR:
      return {
        ...state,
        error: action.payload,
        eventsRequesting: false,
      };

    case SELECT_RECOMMENDED_STEPS_ERROR:
      return {
        ...state,
        error: action.payload,
        requesting: false,
      };

    case USER_CAMPAIGN_SET_NEXT_CATEGORY_REQUESTING: {
      const { nextCategory } = action.payload;
      return {
        ...state,
        campaignSelected: { ...state.campaignSelected, nextCategory },
      };
    }

    case USER_CAMPAIGN_SET_TEAM_RANK: {
      return {
        ...state,
        teamRank: action.payload,
      };
    }

    case USER_CAMPAIGN_SET_USER_RANK: {
      return {
        ...state,
        userRank: action.payload,
      };
    }

    case USER_CAMPAIGN_GET_TEAM_REQUESTING: {
      return {
        ...state,
        teamRequesting: true,
      };
    }

    case ACCEPT_PERFECT_STEP_REQUESTING: {
      return {
        ...state,
        selectionRequesting: true,
      };
    }

    case ACCEPT_PERFECT_STEP_SUCCESS: {
      const currentStepIndex = state.campaignSelected.steps.findIndex(
        el => !el.done,
      );
      const steps = state.campaignSelected.steps.map((el, index) => {
        if (index === currentStepIndex) {
          return {
            ...el,
            content: {
              how: { en: "", fr: "" },
              title: { en: "", fr: "" },
              why: { en: "", fr: "" },
            },
            title: { en: "", fr: "" },
            ...action.payload,
          };
        }
        return el;
      });

      return {
        ...state,
        selectionRequesting: false,
        campaignSelected: { ...state.campaignSelected, steps },
      };
    }

    case VALIDATE_PERFECT_STEP_SUCCESS: {
      const userCampaigns = state.userCampaigns.map((el, index) => {
        if (el._id === action.payload._id) {
          return {
            ...el,
            ...action.payload,
          };
        }
        return el;
      });
      const campaignSelected = { ...state.campaignSelected, ...action.payload };
      return {
        ...state,
        error: "",
        isValidateRequesting: false,
        userCampaigns,
        campaignSelected,
      };
    }

    case USER_CAMPAIGN_GET_SUCCESS:
    case USER_CAMPAIGN_SET_NEXT_CATEGORY_SUCCESS: {
      const userCampaigns = state.userCampaigns.map((el, index) => {
        if (el._id === action.payload._id) {
          return {
            ...el,
            ...action.payload,
          };
        }
        return el;
      });
      const campaignSelected = { ...state.campaignSelected, ...action.payload };
      return {
        ...state,
        error: "",
        requesting: false,
        userCampaigns,
        campaignSelected,
      };
    }

    case ACCEPT_PERFECT_STEP_ERROR: {
      return {
        ...state,
        error: action.payload,
      };
    }

    case USER_CAMPAIGN_GET_ALL_SUCCESS:
      return {
        ...state,
        userCampaigns: action.payload,
        campaignsRequesting: false,
      };

    case USER_CAMPAIGN_GET_TEAM_SUCCESS:

      return {
        ...state,
        team: action.payload,
        teamRequesting: false,
      };

    case CANCEL_SELECTED_STEP_REQUESTING:
      return {
        ...state,
        requesting: true,
      };

    case CANCEL_SELECTED_STEP_ERROR:
      return {
        ...state,
        requesting: false,
        error: action.payload,
      };

    case CANCEL_SELECTED_STEP_SUCCESS: {
      const campaignSelected = { ...state.campaignSelected, ...action.payload };
      return {
        ...state,
        requesting: false,
        stepSelected: defaultStep,
      };
    }

    case GET_SPECIFIC_STEP_SUCCESS:
    case SELECT_PERFECT_STEP_SUCCESS:
      return {
        ...state,
        requesting: false,
        stepSelected: { ...action.payload, step: action.payload._id },
      };

    case CAMPAIGN_JOIN_SUCCESS:
      return {
        ...state,
        requesting: false,
        // campaignSelected: action.payload,
      };

    case VALIDATE_PERFECT_STEP_ERROR:
      return {
        ...state,
        error: action.payload,
        requesting: false,
        isValidateRequesting: false,
      };

    case GET_SPECIFIC_STEP_ERROR:
    case CAMPAIGN_JOIN_ERROR:
    case GET_CURRENT_USER_CAMPAIGN_ERROR:
    case SELECT_PERFECT_STEP_ERROR:
    case USER_CAMPAIGN_GET_ERROR:
      return {
        ...state,
        error: action.payload,
        requesting: false,
      };

    case USER_CAMPAIGN_GET_ALL_ERROR:
      return {
        ...state,
        error: action.payload,
        campaignsRequesting: false,
      };

    case USER_CAMPAIGN_GET_TEAM_ERROR:
      return {
        ...state,
        error: action.payload,
        teamRequesting: false,
      };

    case USER_CAMPAIGN_SELECT:
      return {
        ...state,
        campaignSelected: action.payload,
      };

    case USER_CAMPAIGN_SET_TEAM:
      return {
        ...state,
        team: action.payload,
      };

    case USER_CAMPAIGN_NEW:
      return {
        ...state,
        userCampaigns: [action.payload, ...state.userCampaigns],
      };

    case USER_CAMPAIGN_DELETE: {
      const userCampaigns = state.userCampaigns.filter(
        el => el.campaignId !== action.payload.campaignId,
      );
      let campaignSelected = state.campaignSelected;
      if (campaignSelected.campaignId === action.payload.campaignId) {
        campaignSelected = { ...initialState.campaignSelected };
      }
      return {
        ...state,
        campaignSelected,
        userCampaigns: userCampaigns,
      };
    }

    case ADD_STEP_COMMENT_SUCCESS: {
      const { _id, comment } = action.payload;
      const recommendedSteps = produce(state.recommendedSteps, draft => {
        const step = state.recommendedSteps.find(el => el._id === _id);
        if (!step) return draft;

        if (comment?.stepCommentResponseId) {
          const commentToUpdate = step.comments?.find(
            el => el._id === comment.stepCommentResponseId,
          );
          commentToUpdate?.comments?.push(comment);
        } else {
          step.comments?.push(action.payload.comment);
        }
        return draft;
      });

      return {
        ...state,
        recommendedSteps,
      };
    }

    case GET_STEP_COMMENT_REQUESTING: {
      return {
        ...state,
        stepSelected: {
          ...state.stepSelected,
          stepCommentRequesting: true,
        },
      };
    }

    case GET_STEP_COMMENT_ERROR: {
      return {
        ...state,
        stepSelected: {
          ...state.stepSelected,
          stepCommentRequesting: false,
        },
      };
    }

    case GET_STEP_COMMENT_SUCCESS: {
      /*
          We update activeStep if concerned and stepSelected
      */
      const stepComments = action.payload;

      return {
        ...state,
        stepSelected: {
          ...state.stepSelected,
          comments: stepComments,
          stepCommentRequesting: false,
        },
      };
    }

    case GET_STEP_COMMENT_INFO_SUCCESS: {
      const {
        numberOfComments,
        lastStepComment,
        users,
        stepId,
      } = action.payload;

      const currentStepIndex = state.campaignSelected.steps.findIndex(
        el => !el.done,
      );

      const steps = state.campaignSelected.steps.map((el, index) => {
        if (index === currentStepIndex && el.step === stepId) {
          return {
            ...el,
            numberOfComments,
            lastStepComment,
            users,
          };
        }
        return el;
      });

      return {
        ...state,
        campaignSelected: { ...state.campaignSelected, steps },
        stepSelected: {
          ...state.stepSelected,
          numberOfComments,
          lastStepComment,
          users,
        },
      };
    }

    case GET_ALL_RESPONSES_REQUESTING: {
      return {
        ...state,
        stepSelected: {
          ...state.stepSelected,
          requestedResponses: true,
        },
      };
    }

    case GET_ALL_RESPONSES_SUCCESS: {
      const { responses, stepCommentId } = action.payload;

      const comments = state?.stepSelected?.comments?.map(comment => {
        if (comment._id === stepCommentId) {
          return { ...comment, responses: responses };
        }
        return comment;
      });

      return {
        ...state,
        stepSelected: {
          ...state.stepSelected,
          comments,
          requestedResponses: false,
        },
      };
    }

    case SEND_RESPONSE_REQUESTING: {
      return {
        ...state,
        stepSelected: {
          ...state.stepSelected,
          requestedResponses: true,
        },
      };
    }

    case SEND_RESPONSE_SUCCESS: {
      const { response, stepCommentId } = action.payload;

      const comments = state?.stepSelected?.comments?.map(comment => {
        if (comment._id === stepCommentId) {
          return { ...comment, responses: [...comment.responses, response] };
        }
        return comment;
      });
      const numberOfComments = state?.stepSelected?.numberOfComments + 1;

      return {
        ...state,
        stepSelected: {
          ...state.stepSelected,
          comments,
          numberOfComments,
          requestedResponses: false,
        },
      };
    }

    case REMOVE_COMMENT_REQUESTING: {
      return {
        ...state,
        stepSelected: {
          ...state.stepSelected,
          requestedResponses: true,
        },
      };
    }

    case REMOVE_COMMENT_SUCCESS: {
      const { stepCommentId } = action.payload;

      let numberOfComments = state.stepSelected.numberOfComments;
      const comments = state?.stepSelected?.comments?.map(comment => {
        const responses = comment.responses.filter(
          response => response._id !== stepCommentId,
        );

        if (responses) {
          numberOfComments = numberOfComments - 1;
          return {
            ...comment,
            responses,
          };
        }
        return comment;
      });

      return {
        ...state,
        stepSelected: {
          ...state.stepSelected,
          comments,
          numberOfComments,
          requestedResponses: false,
        },
      };
    }

    case ADD_LIKE_STEP_COMMENT_REQUESTING: {
      const { stepCommentId, userId } = action.payload;

      const comments = produce(state.stepSelected.comments, draft => {
        draft.map(comment => {
          if (comment._id === stepCommentId) {
            comment.like.users.push(userId);
            comment.like.numberOfLike = comment.like.numberOfLike + 1;
          } else {
            comment.responses.map(response => {
              if (response._id === stepCommentId) {
                response.like.users.push(userId);
                response.like.numberOfLike = response.like.numberOfLike + 1;
              }
              return response;
            });
          }
          return comment;
        });
      });

      return {
        ...state,
        stepSelected: {
          ...state.stepSelected,
          comments,
        },
      };
    }

    case REMOVE_LIKE_STEP_COMMENT_REQUESTING: {
      const { stepCommentId, userId } = action.payload;

      const comments = produce(state.stepSelected.comments, draft => {
        draft.map(comment => {
          if (comment._id === stepCommentId) {
            comment.like.users = comment.like.users.filter(
              user => user !== userId,
            );
            comment.like.numberOfLike = comment.like.numberOfLike - 1;

            return comment;
          } else {
            const res = comment.responses.map(response => {
              if (response._id === stepCommentId) {
                response.like.users = response.like.users.filter(
                  user => user !== userId,
                );
                response.like.numberOfLike = response.like.numberOfLike - 1;
              }
              return response;
            });
            return {
              ...comment,
              responses: res,
            };
          }
        });
      });

      return {
        ...state,
        stepSelected: {
          ...state.stepSelected,
          comments,
        },
      };
    }

    case UPDATE_COMMENT_SUCCESS: {
      const { stepCommentId, commentUpdated } = action.payload;

      const comments = state.stepSelected.comments.map(comment => {
        const responses = comment.responses.map(response => {
          if (response._id === stepCommentId) {
            return {
              ...response,
              comment: commentUpdated,
            };
          }
          return response;
        });

        return {
          ...comment,
          responses,
        };
      });

      return {
        ...state,
        stepSelected: {
          ...state.stepSelected,
          comments,
          requestedResponses: false,
        },
      };
    }

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
